import React from "react";

import { useSetRecoilState } from "recoil";
import { modalState } from "lib/store/common";

import {
  Modal,
  ModalImage,
  Marketing as MarketingText,
} from "@atsent/components";

export type MarketingProps = {
  cx?: string;
};

export const Marketing: React.FC<MarketingProps> = ({ cx = "" }) => {
  const setModal = useSetRecoilState(modalState);
  return (
    <Modal
      cx={`SignUpModal ${cx}`}
      close={() => setModal((_) => ({ ..._, market: false }))}
      title={"atsent"}
    >
      <ModalImage text={"마케팅 수신 동의"} />
      <MarketingText />
    </Modal>
  );
};
